const moreContentBlock = document.querySelector('[data-more-content-block]')
const moreContentBtn = document.querySelector('[data-more-content-btn]')

if(moreContentBtn) {
    moreContentBtn.addEventListener('click', function() {
        moreContentBlock.classList.toggle('more')
        if (moreContentBlock.classList.contains('more')) {
            this.children[0].textContent = `Менше`
            this.children[1].style.transform = `rotate(180deg)`
        } else {
            this.children[0].textContent = `Більше`
            this.children[1].style.transform = `rotate(0)`
        }
    })
}
